import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-background',
  templateUrl: './main-background.component.html',
  styleUrls: ['./main-background.component.css']
})
export class MainBackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
